import React from 'react';
import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import { DatePicker} from "@mui/x-date-pickers"
import dayjs from 'dayjs';

const DatePickerController = ({defaultheight=true, name, control, label, errors, readOnly=false, onChange }) => {

  return (
      <Controller
        name={name}
        control={control}
        render={({field})=>(
        <DatePicker
          renderInput={(props)=><TextField {...props} />}
            label={label}
            disabled={readOnly}
            value={field.value ? dayjs(field.value, 'DD-MM-YYYY') : null}
            format='DD/MM/YYYY'
            onChange={(date)=>{
            field.onChange(dayjs(date).format("DD-MM-YYYY"))}}
            error={Boolean(errors[name])}
            helperText={errors[name]?.message}
            maxDate={dayjs()}
            sx={{ 
                "& .MuiInputBase-root ": {
                    height: defaultheight ?  undefined: "35px !important",
                },
                
               "& .MuiInputBase-root input": {
              padding: defaultheight ?  undefined: "8.5px 14.5px 8.5px 8.5px",
              width: "100px !important",
            },
              "& .MuiOutlinedInput-input.Mui-disabled":{
                WebkitTextFillColor: (theme)=>theme.palette.black.main,
              },
              "& .MuiInputLabel-root.Mui-disabled":{
                color:(theme)=>theme.palette.black.main
              }
            }}
        />
        )}
      />
  );
};

export default DatePickerController;